module.exports = __webpack_public_path__ + "account/img/229.026c2d33.png";